import React, { useEffect } from "react"
import { DateRangePicker, CheckPicker } from 'rsuite'
import { useState } from "react"
import PropTypes from "prop-types"
import { ProductStoreFilter } from "../../../gql/query"
//load components
import SelectPickerPaginate from "../SelectPickerPaginate"

const EcommercePayoutsFilter = (props) => {
	const [filterData, setFilterData] = useState([])

	const [filters, setFilters] = useState([])
	const [filterValues, setFilterValues] = useState({})

	const resetFilter = (value) => {
		const filtersTemp = filters.filter(item => item !== value)
		setFilters(filtersTemp)
	}
	const getFilterCondition = (filterKey) => {
		if (props.filterQueryConditions !== null) {
			let condition = props.filterQueryConditions.filter(condition => condition.filter === filterKey)
			if (condition.length) {
				return condition[0]?.condition
			}
		} else {
			return null
		}
	}
	useEffect(() => {
		props.onFilterChange(filterValues)
	}, [filterValues])
	useEffect(() => {
		if (filters.length) {
			let filterValuesTemp = { ...filterValues }
			if (!filters.includes("created_at")) {
				delete filterValuesTemp["created_at"]
			} 
			if (!filters.includes("store")) {
				delete filterValuesTemp["store"]
			} 
			setFilterValues(filterValuesTemp)
		} else {
			setFilterValues({})
		}
	}, [filters])

	useEffect(() => {
		let filterDataTemp = []
		props.activeFilters.map((filter) => {
			if (filter === "store") {
				filterDataTemp.push({ label: "Store", value: "store" })
			}
			if (filter === "created_at") {
				filterDataTemp.push({ label: "Created At", value: "created_at" })
			}
		})
		setFilterData(filterDataTemp)
	}, [props.activeFilters])
	return (
		<div className="auto-horizontal-scroll">
			<CheckPicker
				data={filterData}
				placeholder={"Filter"}
				style={{ width: 130 }}
				value={filters}
				onChange={setFilters}
				searchable={false}
			/>
			{filters.map((filter, i) => {
				if (filter === "created_at") {
					return (
						<React.Fragment key={i}>
							<DateRangePicker
								placement="auto"
								onChange={(created_at) => setFilterValues({ ...filterValues, created_at })}
								style={{ marginLeft: 10 }}
								placeholder="Select Created At Date"
								value={Array.isArray(filterValues.created_at) ? filterValues.created_at : []}
							/>
							<div style={{ marginLeft: 5, cursor: "pointer", height: 40, display: "flex", alignItems: "center" }} onClick={() => resetFilter("created_at")}>
								<i className="bx bx-x-circle" />
							</div>
						</React.Fragment>
					)
				}
				if (filter === "store") {
					return (
						<React.Fragment key={i}>
							<SelectPickerPaginate
								query={ProductStoreFilter}
								placeholder="Select Store"
								value={filterValues.store}
								onChange={(store) => setFilterValues({ ...filterValues, store })}
								arrKey="stores"
								objectLabel="name"
								objectValue="id"
								style={{ marginLeft: 10 }}
								paginate={true}
								filterCondition={getFilterCondition("store")}
							/>
							<div style={{ marginLeft: 5, cursor: "pointer", height: 40, display: "flex", alignItems: "center" }} onClick={() => resetFilter("store")}>
								<i className="bx bx-x-circle" />
							</div>
						</React.Fragment>
					)
				}
			})}
		</div>
	)
}
EcommercePayoutsFilter.propTypes = {
	onFilterChange: PropTypes.func,
	activeFilters: PropTypes.array,
	filterQueryConditions: PropTypes.any
}
export default EcommercePayoutsFilter